import { NoddiButton, NoddiIconButton } from 'noddi-ui-web';
import type { ComponentType, ReactNode } from 'react';
import { signupLicensePlateLimit } from './verifiedSignupFormSchema';

type PlateArrayField = {
  state: { value: string[] };
  pushValue: (value: string) => void;
  removeValue: (index: number) => void;
};

type PlateInputField = {
  Input: (props: { label?: string; 'aria-label'?: string }) => ReactNode;
};

type Props = {
  /**
   * `form.AppField` from `useAppForm`. Typed loosely — TanStack FieldComponent
   * generics are not practical to share across a shared field group.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- form.AppField generics from TanStack FieldComponent are not practical to share across forms
  Field: ComponentType<any>;
  label: string;
  addLabel: string;
  removeLabel: string;
};

export const SignupLicensePlateFields = ({ Field, label, addLabel, removeLabel }: Props) => (
  <Field name='licensePlateNumbers' mode='array'>
    {(arrayField: PlateArrayField) => (
      <div className='flex flex-col gap-2'>
        {arrayField.state.value.map((_, index) => (
          <div key={index} className='flex items-end gap-2'>
            <div className='min-w-0 flex-1'>
              <Field name={`licensePlateNumbers[${index}]`}>
                {(field: PlateInputField) => (
                  <field.Input label={index === 0 ? label : undefined} aria-label={index === 0 ? undefined : label} />
                )}
              </Field>
            </div>
            {arrayField.state.value.length > 1 && (
              <NoddiIconButton
                iconName='Trash2'
                variant='ghost'
                aria-label={removeLabel}
                onClick={() => arrayField.removeValue(index)}
              />
            )}
          </div>
        ))}
        {arrayField.state.value.length < signupLicensePlateLimit && (
          <NoddiButton
            variant='outline'
            startIcon='Plus'
            className='self-start'
            onClick={() => arrayField.pushValue('')}
          >
            {addLabel}
          </NoddiButton>
        )}
      </div>
    )}
  </Field>
);
